import apiService from '../apiService';

const customFieldService = {
  
  async createCustomField(payload) {
    try {
      const response = await apiService.post(`/settings/custom-fields`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async getAllCustomFields(payload) {
    try {
      const queryParams = new URLSearchParams(payload).toString();
      const response = await apiService.get(`/settings/custom-fields?${queryParams}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async getSingleCustomFields(id) {
    try {
      const response = await apiService.get(`/settings/custom-fields/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async updateCustomField(payload, id) {
    try {
      const response = await apiService.put(`/settings/custom-fields/${id}`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async deleteCustomField(id) {
    try {
      const response = await apiService.delete(`/settings/custom-fields/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
};

export default customFieldService;